/**
 * Cookie consent storage helpers (Luxembourg / CNPD: consent valid max. 12 months).
 */

export interface CookieConsent {
  necessary: true;
  functional: boolean;
  analytics: boolean;
  timestamp: string;
}

export const COOKIE_CONSENT_KEY = 'velox_cookie_consent';
export const OPEN_COOKIE_SETTINGS_EVENT = 'velox:open-cookie-settings';
const TWELVE_MONTHS_MS = 365 * 24 * 60 * 60 * 1000;

export const readConsent = (): CookieConsent | null => {
  try {
    const raw = window.localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CookieConsent;
    if (!parsed?.timestamp) return null;
    if (Date.now() - new Date(parsed.timestamp).getTime() > TWELVE_MONTHS_MS) return null;
    return { ...parsed, necessary: true };
  } catch {
    return null;
  }
};

export const saveConsent = (choice: { functional: boolean; analytics: boolean }): CookieConsent => {
  const consent: CookieConsent = {
    necessary: true,
    functional: choice.functional,
    analytics: choice.analytics,
    timestamp: new Date().toISOString(),
  };
  try {
    window.localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consent));
  } catch {
    /* storage unavailable */
  }
  window.dispatchEvent(new CustomEvent('velox:cookie-consent-updated', { detail: consent }));
  return consent;
};

export const openCookieSettings = () => {
  window.dispatchEvent(new CustomEvent(OPEN_COOKIE_SETTINGS_EVENT));
};
